// extracted by mini-css-extract-plugin
export default {"PauseModal":"PauseModal_PauseModal__bJelF"};